




import { pageFactory } from '@/main/pages/pageFactory';
import { pageStoreBuilder } from '@/main/store/pages/page/builder';

const name = 'SqlLog';

export default pageFactory(name, pageStoreBuilder({
	name,
	crumbLabel: 'SqlLog',
	dropdownList: {},
	localState: {},
	props: {
		mode: null,
	},
}));
